import React from 'react';
import { Row, Col, Button } from 'antd';
import moment from '~/_moment';
import PressureFilterSensor from './PressureFilterSensor';
import {
  FlexBox,
  DamTitle,
  DatePickerStyle,
  TimePickerStyle,
  TimeSelector,
  RetrieveBtn,
  DivToStyle,
} from './style';

const forceDisable = (current, date) => {
  const disableFuture = current >= moment().endOf('day');
  if (date) {
    return current <= moment(date, 'YYYY-MM-DD').endOf('day') || disableFuture;
  }

  return disableFuture;
};

const PressureFilters = ({
  showSensorFilter,
  showTimePicker,
  siteName,
  isPressureloading,
  dateValue,
  sensorValue,
  startTimeValue,
  endTimeValue,
  handleChangeDate,
  handleChangeStartTime,
  handleChangeEndTime,
  handleLoadData,
  handleChangeSensor,
  subTitle,
  disabledDate,
  totalSensor,
  waterLevelSensor,
  enableDownloadCSV,
}) => {
  const fullStartDate = `${moment(dateValue, 'YYYY-MM-DD').format('YYYY-MM-DD')} ${moment(
    startTimeValue,
    'HH:mm',
  ).format('HH:mm:ss')}`;
  const fullEndDate = `${moment(dateValue, 'YYYY-MM-DD').format('YYYY-MM-DD')} ${moment(
    endTimeValue,
    'HH:mm',
  ).format('HH:mm:ss')}`;

  return (
    <Row>
      <Col sm={12} offset={1}>
        <DamTitle className="gray quark_bold margin_bottom_0">{`โครงการ${siteName}`}</DamTitle>
        <p>{subTitle}</p>
        {showSensorFilter && (
          <PressureFilterSensor
            totalSensor={totalSensor}
            value={sensorValue}
            waterLevelSensor={waterLevelSensor}
            handleChangeSensor={handleChangeSensor}
          />
        )}
      </Col>
      <FlexBox direction="column">
        <FlexBox justify="flex-end">
          <b style={{ marginBotton: 0, marginTop: '20px' }}>เลือกช่วงเวลาที่ต้องการตรวจสอบ</b>
        </FlexBox>
        <TimeSelector justify="flex-end">
          <b>ระบุวันที่</b>
          <FlexBox width="302px">
            <DatePickerStyle
              format="DD MMMM YYYY"
              allowClear={false}
              value={moment(dateValue, 'YYYY-MM-DD')}
              // disabledDate={(currentDate) => forceDisable(currentDate, disabledDate)}
              onChange={(e) => handleChangeDate(e.format('YYYY-MM-DD'))}
            />
          </FlexBox>
        </TimeSelector>

        {showTimePicker && (
          <TimeSelector justify="flex-end">
            <b>ระบุช่วงเวลา</b>
            <FlexBox itemsAlign="center" width="302px">
              <TimePickerStyle
                format="HH:mm"
                allowClear={false}
                minuteStep={5}
                value={moment(startTimeValue, 'HH:mm')}
                onChange={(e) => handleChangeStartTime(e.format('HH:mm'))}
              />
              <DivToStyle>ถึง</DivToStyle>
              <TimePickerStyle
                format="HH:mm"
                allowClear={false}
                minuteStep={5}
                value={moment(endTimeValue, 'HH:mm')}
                onChange={(e) => handleChangeEndTime(e.format('HH:mm'))}
              />
            </FlexBox>
          </TimeSelector>
        )}

        <RetrieveBtn justify="flex-end">
          <Button type="danger" loading={isPressureloading} onClick={() => handleLoadData()}>
            {isPressureloading ? 'กำลังเรียกข้อมูล...' : 'เรียกข้อมูล'}
          </Button>
          &nbsp;
          {enableDownloadCSV && (
            <a
              className="ant-btn ant-btn-dashed"
              type="button"
              href={`/rest/pressure/csv?start=${fullStartDate}&end=${fullEndDate}`}
              target="_blank"
            >
              Download CSV
            </a>
          )}
        </RetrieveBtn>
      </FlexBox>
    </Row>
  );
};

PressureFilters.defaultProps = {
  subTitle: 'ระบบรายงานสภาพแรงดันภายในเขื่อน',
  disabledDate: false,
  totalSensor: 0,
  waterLevelSensor: false,
  enableDownloadCSV: false,
};

export default PressureFilters;



// WEBPACK FOOTER //
// ./resources/assets/js/components/PressureFilters/PressureFilters.js